import * as generalTypes from '../types/generalTypes'

const initialState = {
  allData: null,
  allNumbersData: null,
  customerSegmentation: '',
  inActiveCustomerSegmentation: '',
  customerLifetimeValue: [],
  productCategory: [],
  productSubCategory: [],
  productSubCategory2: [],
  spendingType: '',
  location: [],
  status: '',
  countOnly: '',
}

const conditionalReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case generalTypes.GET_CONDITIONAL_CUSTOMER_COUNT:
      return {
        ...state,
        allData: payload,
      }
    case generalTypes.GET_CONDITIONAL_CUSTOMER_NUMBERS:
      return {
        ...state,
        allNumbersData: payload,
      }
    case generalTypes.SAVE_CONDITIONAL_CAMPAIGN:
      return {
        ...state,
        allData: payload,
      }
    case generalTypes.GET_ALL_SAVE_CONDITIONAL_CAMPAIGN:
      return {
        ...state,
        allData: payload,
      }
    case generalTypes.DELETE_SAVE_CAMPAIGN:
      return {
        ...state,
        allData: payload,
      }
    default:
      return state
  }
}

export default conditionalReducer
